membershipApp.controller('MembershipPurchaseController', ['$scope', '$http', '$timeout', '$translate', '$filter', function ($scope, $http, $timeout, $translate, $filter) {
	// Purchase Page
    $('body').addClass('clean-page');
	var $translateThis = $filter('translate');
	$scope.lockMembership = false;
	$scope.onePageloading = false;
	$scope.additionalConfirmationOnline = true;
    $scope.Discount = 0;
	$scope.expiredStartingDate = false;
	$scope.RequestNetcashMandate = false;
	var today = new Date();
	var dd = today.getDate();
	var mm = today.getMonth() + 1;
	var yyyy = today.getFullYear();


	if (dd < 10) {
		dd = '0' + dd
	}

	if (mm < 10) {
		mm = '0' + mm
	}

	today = mm + '/' + dd + '/' + yyyy;

    $scope.$watch('paymentway', function (v) {
		var paymentWayValue = v;

		if (paymentWayValue == '9') {

			// $('.onepage-wrapper .actions .stripe-button').addClass('show');
			// Create a Stripe client.
			$scope.stripe = Stripe($scope.membershipSettings.StripePublishKey);
			// Create an instance of Elements.
			var elements = $scope.stripe.elements();
			// Custom styling can be passed to options when creating an Element.
			// (Note that this demo uses a wider set of styles than the guide below.)
			var style = {
			  base: {
				color: '#32325d',
				lineHeight: '18px',
				fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
				fontSmoothing: 'antialiased',
				fontSize: '16px',
				'::placeholder': {
				  color: '#aab7c4'
				}
			  },
			  invalid: {
				color: '#fa755a',
				iconColor: '#fa755a'
			  }
			};


			// Create an instance of the card Element.
			// $scope.card = elements.create('card', {style: style});
			$scope.card = elements.create('card', {style: style, hidePostalCode: $scope.membershipSettings.HidePostalCode });

			// Add an instance of the card Element into the `card-element` <div>.
			$scope.card.mount('#card-element');

			// Handle real-time validation errors from the card Element.
			$scope.stripeError = document.getElementById('card-errors');
			$scope.card.addEventListener('change', function(event) {
			  	if (event.error) {
					$scope.stripeError.textContent = event.error.message;
			  	} else {
					$scope.stripeError.textContent = '';
			  	}
			});

			// $('.stripe-button').on('click', function(e){
			// 	e.preventDefault();
			// 	$scope.getTerms(true)
			//     // if ($scope.orderLoading == false || $scope.orderLoading == undefined) {
			//     //     $scope.orderLoading = true;
			        
			//     // }
				
			// })
		}else{
			// $('.onepage-wrapper .actions .stripe-button').removeClass('show');
		}
	});

	// Get Gyms
	$scope.getGyms = function () {
		var dataObject = {
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/Membership/GetGyms',
			data: dataObject
		}).success(function (data) {
			$scope.membershipGyms = data;

		}).error(function () {
			// console.log('error');
		});
	}

	$scope.getGyms();


    $scope.getTerms = function(provider){
		$scope.RequestNetcashMandate = false;
		$scope.onePageloading = true;
		var startDate = new Date($scope.theChoosenMembershipDate);
		startDate.setHours(0,0,0,0);
		let lang = $translate.proposedLanguage() || $translate.use();
		var dataObject = {
			Namespace: namespace,
			GymID: $scope.DivisionID,
			ClientID: -1,
			ServiceID: $scope.theChoosenMembership.ServiceDefinitionID,
			Discount: $scope.Discount,
			DateStart: startDate,
			Email: $scope.Email,
			OrderType: 'PURCHASE',
			MyPos: false,
			Cpay: false,
			NetCash: false,
			Language: lang,
			InitialPayment: true,
			PromoCode: $scope.promocodeFalse ? '' : $scope.PromoCode
		}

		if($scope.validatedMobileUser){
			dataObject.ClientID = clientId;
		}

		if($scope.clientGroupMember){
			dataObject.ClientID = $scope.clientGroupMember.ClientID;
		}

		if(provider == 'stripe'){
			dataObject.GenerateIntent = true;
		}else if(provider == 'elavon'){
			dataObject.GenerateElavonToken = true;
		}else if(provider == 'mypos'){
			dataObject.MyPos = true;
		}else if(provider == 'netcash' || provider == 'netcashmandate'){
			dataObject.NetCash = true;
		}else if(provider == 'cpay'){
			dataObject.Cpay = true;
		}

		$http({
			method: 'POST',
			url: '/Membership/Terms',
			data: dataObject
		}).success(function (data) {

			$scope.RequestNetcashMandate = data.RequestNetcashMandate;
			if(provider == 'netcashmandate'){
				if($scope.RequestNetcashMandate){
					$timeout(function() {
						$scope.mainPaymentWay = 'netcashmandate'
					}, 1);
				}else{
					$timeout(function() {
						$scope.mainPaymentWay = '';
					}, 1);
				}
			}

			if(data == 'User doesn`t exists!'){
				var translated = $translateThis('User doesn`t exists!');
				Swal.fire({
	                type: 'warning',
                    title: translated,
					onAfterClose: (function () {
                        $timeout(function() {
							$scope.onePageloading = false;
						});
                    })
	            })
			}else if(data != 'Аlready has recurring membership!'){
				$scope.theChoosenMembership.OriginalPrice = data.Price;

				if(provider == 'stripe'){
					if(data.StripeValues && data.StripeValues.Success){
						window.location.href = data.StripeValues.Url;
					}else if(data.StripeValues && data.StripeValues.Error){
						Swal.fire({
							type: 'warning',
							title: 'error',
							onAfterClose: (function () {
								$timeout(function() {
									$scope.loading = false;  
								});
							})
						});	
					}else{
						$scope.PaymentIntentID = data.PaymentIntentID;
						$scope.MembershipOrderID = data.MembershipOrderID;
						let secret = data.ClientSecret;
		
						stripeConfirmCard(secret);
					}
				}else if(provider == 'elavon'){
					openLightbox(data.ElavonToken);
				}else if(provider == 'mypos'){
					$scope.placeOrder();
				}else if(provider == 'cpay'){
					$scope.placeOrder();
				}else if(provider == 'netcash'){
					$scope.placeOrder();
				}else{
					$scope.onePageloading = false;
				}
			}else{
				var translated = $translateThis('Recurring service exist! OnePage');
				Swal.fire({
	                type: 'warning',
	                title: translated,
					onAfterClose: (function () {
						$timeout(function() {
							$scope.onePageloading = false;
						});
                    })
	            })
			}
			
		}).error(function (error) {
			$scope.onePageloading = false;
			if(provider == 'stripe'){
				$scope.stripeError.textContent = error.ExceptionMessage;
			}else{
				Swal.fire({
					type: 'warning',
					title: 'error',
					onAfterClose: (function () {
						$timeout(function() {
							$scope.onePageloading = false;  
						});
					})
				});	
			}
		});
	}

	function post_to_url(params, method, url) {
		let path = $scope.membershipSettings.MyPosTestingMode ? 'https://www.mypos.com/vmp/checkout-test' : 'https://www.mypos.com/vmp/checkout';
		if(url){
            path = url;
        }
		method = method || "post";
	
		var form = document.createElement("form");
		form.setAttribute("method", method);
		form.setAttribute("action", path);
	
		for(var key in params) {
			if(params.hasOwnProperty(key)) {
				var hiddenField = document.createElement("input");
				hiddenField.setAttribute("type", "hidden");
				hiddenField.setAttribute("name", key);
				hiddenField.setAttribute("value", params[key]);
	
				form.appendChild(hiddenField);
			 }
		}
	
		document.body.appendChild(form);
		form.submit();
	}

	function openLightbox(token) {
        var paymentFields = {
            ssl_txn_auth_token: token
        };
        var callback = {
            onError: function (error) {
                Swal.fire({
                    type: 'warning',
                    title: 'error',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.onePageloading = false; 
                        });
                    })
                });

                showResult("error", error,token);
            },
            onCancelled: function () {
                // showResult("cancelled", "",token);
                Swal.fire({
                    type: 'warning',
                    title: 'Cancelled',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.onePageloading = false; 
                        });
                    })
                });
            },
            onDeclined: function (response) {
                showResult("declined", JSON.stringify(response, null, '\t'), token);
                Swal.fire({
                    type: 'warning',
                    title: 'Declined',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.onePageloading = false; 
                        });
                    })
                });
            },
            onApproval: function (response) {
				$scope.ElavonTransactionID = response.ssl_txn_id;
                $scope.ElavonOrderID = response.ssl_invoice_number;

				$scope.placeOrder();

                // showResult("approval", JSON.stringify(response, null, '\t'),token);
            }
        };
        PayWithConverge.open(paymentFields, callback);
        return false;
	}

	function showResult(status, msg, token) {
		console.log(status, msg)

		let url = '/membership/SaveElavonError/';
		let dataObject = {
			Token: token,
			Status: status,
			ExceptionText: msg,
			NameSpace: namespace
		}

		$http({
			method: 'POST',
			url: url,
			data: dataObject
		});
	}

	if ( settings ) {
		$scope.settings = settings;
	}

	function checActivePaymentMethods(settings){
		const paymentMethods = [];
		const activePaymentMethod = [];
		paymentMethods.push({name: 'epay', value: settings.EPay}, {name: 'stripe', value: settings.StripePublishKey ? true : false}, { name: 'commbank', value: settings.CommBankPublicApiKey ? true : false});
		paymentMethods.filter((element) => {
			if (element.value){
				activePaymentMethod.push(element);
			}
		} )

		if(activePaymentMethod.length == 1 ){
			$timeout(function() {
				$scope.mainPaymentWay = activePaymentMethod[0].name;
			})
		}
	}

	if(redirected && sessionStorage.storageinfo){
		var storageinfo = JSON.parse(sessionStorage.storageinfo); 
		
		$timeout(function() {
			$scope.Email = storageinfo.Email
		});
		sessionStorage.clear();
	}

	$scope.$watch('mainPaymentWay', function (v) {

		$scope.paymentway = '';
		
		$timeout(function() {
			if ( v == 'stripe' ) {
				$scope.paymentway = 9;
			}else if(v == 'stripemandate'){
				$scope.paymentway = 98;
			}else if(v == 'settle'){
				$scope.paymentway = 10;
			}else if(v == 'elavon'){
				$scope.paymentway = 11;
			}else if(v == 'mypos'){
				$scope.paymentway = 12;
			}else if(v == 'netcash'){
				$scope.paymentway = 13;
			}else if(v == 'fibank'){
				$scope.paymentway = 8;
			}else if(v == 'netcashmandate'){
				$scope.paymentway = 99;
			}else if($scope.theChoosenMembership && $scope.theChoosenMembership.OriginalPrice == 0){
				$scope.paymentway = 0;
			}else if(v == 'cpay'){
				$scope.paymentway = 14;
			}
		})
	});

	$scope.theChoosenMembershipIsFree = false;
	$scope.getMembership = function(id){

        $scope.mainPaymentWay = '';
		var result = $scope.memberships.filter(function (obj) {
			return obj.ServiceDefinitionID == id;
		});

		$scope.theChoosenMembership = result[0];
		if($scope.theChoosenMembership.FixedDate){
			let now = new Date();
			now.setHours(0,0,0,0);
			let membershipDate = new Date($scope.theChoosenMembership.FixedStartingDate);

			$scope.theChoosenMembershipDate = membershipDate;
			$('#membdatepicker').datepicker('setDate', new Date(membershipDate));
			$('#membdatepicker').datepicker('disable');

			if(membershipDate >= now){
				$scope.expiredStartingDate = false;
			}else{
				$scope.expiredStartingDate = true;
			}
		}else{
			$scope.expiredStartingDate = false;
			$scope.theChoosenMembershipDate = new Date();
			$('#membdatepicker').datepicker('setDate', new Date());
			$('#membdatepicker').datepicker('enable');
		}

		if( $scope.theChoosenMembership.Fibank == true ){
			$scope.orderCardReccuring = true;
		}else{
			$scope.orderCardReccuring = false;	
		}

		if ( $scope.theChoosenMembership.OriginalPrice == 0 ){
			$timeout(function() {
				$scope.theChoosenMembershipIsFree = true;
				$('#payment-free').prop("checked", true).trigger("click");
				$scope.paymentway = 0;
			});
		}else{
			$scope.theChoosenMembershipIsFree = false;
			$scope.paymentway = null;
			getFinalPrice($scope.theChoosenMembership.OriginalPrice);
			$scope.getTerms();
		}

		if($scope.theChoosenMembership.RequiresAdditionalConfirmationOnline){
			$scope.additionalConfirmationOnline = false;
		}
		$scope.choosenMembership = true;

		if($scope.choosenMembership && $inputEmail.is('.ng-valid') && !$scope.NewAccount && $scope.validateUser)
	  		typingEmail = setTimeout(function() {checkServicesToPurchase()}, 2000);



		getCompanyInfo();
	}
	function getCompanyInfo(){
		$scope.currentGym = $scope.membershipGyms.find(o => o.GymID === $scope.DivisionID);
	}
	function getFinalPrice(price){
		if (price.toString().indexOf(".") == -1 ) {
	        $scope.finalBankPrice = price + '00';
	    }else{
	        $scope.finalBankPrice = price.toString().split('.').join("");
	    }

	    $scope.finalBankPrice = parseInt($scope.finalBankPrice);
	}

	
	$scope.placeOrderLink = function(){
		if ( $scope.paymentway == 9 ) {
			$scope.getTerms('stripe');
		}else if($scope.paymentway == 98){
			$scope.getTerms('stripe');
		}else if($scope.paymentway == 11){
			$scope.getTerms('elavon');
		}else if($scope.paymentway == 12){
			$scope.getTerms('mypos');
		}else if($scope.paymentway == 13){
			$scope.getTerms('netcash');
		}else if($scope.paymentway == 14){
			$scope.getTerms('cpay');
		}else{
			$scope.placeOrder();
		}


		// Run this on the page where you want to disable back navigation
		history.pushState(null, null, location.href);
		window.onpopstate = function () {
			history.go(1); // Forces browser forward, creating a loop
		};
	}
	$scope.placeOrder = function(sendProcessPayment = false){
		$scope.onePageloading = true;
		let processPayment = true;
		var paymentProvider = '';
		let price = $scope.theChoosenMembership.OriginalPrice;

		if ( $scope.paymentway == 1 ) {
			paymentProvider = 'paylogin';
		}else if ( $scope.paymentway == 2 ){
			paymentProvider = 'credit_paydirect';
		}else if ( $scope.paymentway == 9 ){
			paymentProvider = 'stripe card';
			processPayment = false;
		}else if ( $scope.paymentway == 8 ){
			paymentProvider = 'Fibank';
		}else if ( $scope.paymentway == 0 ){
			paymentProvider = '0';
		}else if ( $scope.paymentway == 10 ){
			paymentProvider = 'settle';
		}else if ( $scope.paymentway == 11 ){
			paymentProvider = 'elavon';
		}else if ( $scope.paymentway == 12 ){
			paymentProvider = 'MyPos';
		}else if ( $scope.paymentway == 13 || $scope.paymentway == 99 ){
			paymentProvider = 'NetCash';
		}else if ( $scope.paymentway == 14 ){
			paymentProvider = 'cpay';
		}

		if(sendProcessPayment)
			processPayment = true;

		var startDate = new Date($scope.theChoosenMembershipDate);
		startDate.setHours(0,0,0,0);
		if($scope.inputPhone){
			var number = $scope.inputPhone.selectedDialCode.innerHTML + $scope.inputPhone.telInput.value;
			number = number.replace(/ /g,'');
		}
		let lang = $translate.proposedLanguage() || $translate.use();

		var dataObject = { 
			GymID: $scope.DivisionID, 
			Namespace: namespace, 
			model: { FirstName: $scope.FirstName, LastName: $scope.LastName, Email: $scope.Email, Password: $scope.Password, Telephone: number, MembershipID: $scope.membershipId, PaymentProvider: paymentProvider, Token: $scope.token, MembershipID: $scope.theChoosenMembership.ServiceDefinitionID, Date: startDate, Note: $scope.Note, PromoCode: $scope.promocodeFalse ? '' : $scope.PromoCode, price: price, PaymentIntentID: $scope.PaymentIntentID, receiveEmails: $scope.receiveEmails, ProcessPayment: processPayment,Language: lang,MyPos: false, Cpay: false, NetCash: false, MobileAppPurchase: $scope.validatedMobileUser, InitialPayment: true, RequestNetcashMandate: $scope.RequestNetcashMandate }
		};

		if ($scope.paymentway == 9) {
			dataObject.model.MembershipOrderID = $scope.MembershipOrderID
		}

		if ($scope.paymentway == 11) {
			dataObject.model.ElavonOrderID = $scope.ElavonOrderID;
			dataObject.model.ElavonTransactionID = $scope.ElavonTransactionID;
		}

		if ($scope.paymentway == 12) {
			dataObject.model.MyPos = true;
		}

		if ($scope.paymentway == 14) {
			dataObject.model.Cpay = true;
		}

		if ($scope.paymentway == 13 || $scope.paymentway == 99) {
			dataObject.model.NetCash = true;
		}

		if($scope.validatedMobileUser){
			dataObject.model.ClientId = clientId;
			dataObject.model.OwnerClientID = clientId;
		}
		// ClientID: $scope.clientGroupMember ? $scope.clientGroupMember.ClientID : $scope.clientInfo.ClientID,
		if($scope.clientGroupMember){
			dataObject.model.ClientId = $scope.clientGroupMember.ClientID;
		}

		$http({
			method: 'POST',
			url: '/Membership/PurchaseAndRegister',
			data: dataObject
		}).success(function (data) {

			if( paymentProvider == 'cpay' && data.Success == true ){
				post_to_url(data, 'post', data.PaymentUrl);
			}else if ( data.Success == true ){
				window.location.href = data.MandateURL;
			}else if (data.Success == false){
				Swal.fire({
					type: 'warning',
					title: data.Message,
					onAfterClose: (function () {
						$timeout(function() {
							$scope.loading = false;
						});
					})
				});
			}else if (data.myPosStatus == 'succeeded') {
				post_to_url(data.myPosValues, 'post');
			}else if (data.netCashStatus == 'succeeded') {
				post_to_url(data.netCashValues, 'post', 'https://paynow.netcash.co.za/site/paynow.aspx');
			}else if ( data.Key == 1 || data.Key == 2 || data.Key == 3 ){
				Swal.fire({
	                type: 'warning',
	                title: data.Value,
					onAfterClose: (function () {
						$timeout(function() {
							$scope.onePageloading = false;
						});
					})
	            })
			}else if ( data.Key == 0 ){
				var translated = $translateThis('Payment finished with success.');
				var href = window.location.href;
				if ( $scope.validatedMobileUser == true ) {
					href += '&PurchaseViewSuccess=true';
				}  
				Swal.fire({
	                type: 'success',
                    title: translated,
					onAfterClose: (function () {
						$timeout(function() {
							$scope.onePageloading = false;
						});
					})
	            })
			}else if ( data == 'Error' ){
				var translated = $translateThis('buyError');
				Swal.fire({
	                type: 'warning',
	                title: translated,
					onAfterClose: (function () {
						$timeout(function() {
							$scope.onePageloading = false;
						});
					})
	            })
			}else if ( data == 'Recurring service exist!' ){
				var translated = $translateThis('Recurring service exist! OnePage');
				Swal.fire({
	                type: 'warning',
	                title: translated,
					onAfterClose: (function () {
						$timeout(function() {
							$scope.onePageloading = false;
						});
					})
	            })
			}else if ( data == 'succeeded' ){
				var translated = $translateThis('Payment finished with success.');
				var href = window.location.href;
				if ( $scope.validatedMobileUser == true ) {
					href += '&PurchaseViewSuccess=true';
				}  

				Swal.fire({
	                type: 'success',
                    title: translated,
                    onAfterClose: (function () {
                        window.location.replace(href);
                    })
	            })
			}else if ( data == 'done' ){
				if ( $scope.paymentway == 9 ){
					// $('.onepage-wrapper .actions .stripe-button').trigger('click');
				}
			}else if ( data == 'Waiver Required!'){
				populateStorage($scope.NewAccount);
				var translated = $translateThis('Waiver Required!');
				var waiverHref = window.location.origin + '/waiver/embedregistration?GymID=' + $scope.DivisionID + '&NameSpace=' + namespace + '&Redirect=/membership/purchasev2';
				Swal.fire({
					type: 'warning',
					title: translated,
					showCancelButton: true,
				}).then(function(result) {
					if (result.value) {
						window.location.href = waiverHref;
					}else{
						sessionStorage.clear();
						$timeout(function() {
							$scope.onePageloading = false;
						}, 1);
					}
				});
			}else if (data == 'Service Definition Not Found!' || data == 'Payment request error' || data == 'Invalid settle merchant settings' || data == 'Invalid value for customer'){
				Swal.fire({
					type: 'warning',
					title: data,
					onAfterClose: (function () {
						$timeout(function() {
							$scope.onePageloading = false;
						});
					})
				});
			}else if(data == 'Pending'){
				let text = 'Pending... Follow Settle instructions!'
				Swal.fire({
					type: 'success',
					title: text,
					onAfterClose: (function () {
						$timeout(function() {
							$scope.onePageloading = false;
						});
					})
				});
			}else{
				window.location.href = data;
				
			}

		}).error(function () {
			$scope.onePageloading = false;			
		});
	}
	

	$scope.validateForm = function(){
		$scope.validateUser = false;
		if($scope.NewAccount){
			registerUser();
		}else{
			validetUser();
		}
	}

	$scope.changeUser = function(){
		$scope.validateUser = false;
		$scope.clientGroupMember = null;
	}

	$scope.validateUser = false;
	$scope.validatedMobileUser = false;

	function validetUser(){

		let dataObject = {
			Email: $scope.Email, 
			Password: $scope.Password,
			Namespace: namespace
		}
		
		$http({
			method: 'POST',
			url: '/Membership/ValidateUser',
			data: dataObject
		}).success(function (data) {

			if(data == 'Success'){

				$scope.validateUser = true;
				getClientMembership();
			}else{
				let translated = $translateThis(data);

				Swal.fire({
					type: 'warning',
					title: translated,
				})
			}

		}).error(function (error) {
			
		});
	}

	function getClientMembership(email){

		let dataObject = {
			Namespace: namespace,
			Email: email ? email : $scope.Email
		}
		
		$http({
			method: 'POST',
			url: '/Membership/GetClientGroupMembersFastPurchase',
			data: dataObject
		}).success(function (data) {
			$scope.clientGroupMembers = data;

			if(data.length > 1){

			}else{
				if($scope.theChoosenMembership){
					checkServicesToPurchase(email);
					$scope.getTerms('netcashmandate');
				}
			}

			$([document.documentElement, document.body]).animate({
				scrollTop: $("#checkout").offset().top
			}, 1000);


			// if(data.length == 1 && data[0].ClientID == $scope.clientInfo.ClientID){
			// 	$scope.clientGroupMembers = [];
			// }

			// if ($scope.membershipGyms.length == 1 && ($scope.clientGroupMembers != undefined && $scope.clientGroupMembers.length > 0)) {
				
			// 	$scope.getCards($scope.membershipGyms[0].GymID);
			// }


		}).error(function (error) {
			console.log(error);
		});
	}

	$scope.changeClientGroupMember = function(){
		if(typeof $scope.clientGroupMemberSel === 'string'){
			$scope.clientGroupMember = JSON.parse($scope.clientGroupMemberSel);
			checkServicesToPurchase();
			$scope.getTerms('netcashmandate');
		}
	}

	$scope.validatedMobileUser = false;
	if(clientId){
		validateMobileUser();
		$scope.validatedMobileUser = true;
	}
	function validateMobileUser(){
		let dataObject = {
			ClientId: clientId,
			Namespace: namespace
		}
		
		$http({
			method: 'POST',
			url: '/Membership/ValidateUserMobileApp',
			data: dataObject
		}).success(function (data) {

			if(data.Status == 'Success'){
				$scope.validateUser = true;
				$scope.validatedMobileUser = true;
				$inputEmail.val(data.Email);
				$scope.Email = data.Email;

				getClientMembership(data.Email);
				// $scope.getTerms('netcashmandate');
			}else{
				$scope.validatedMobileUser = false;
				let translated = $translateThis(data);

				Swal.fire({
					type: 'warning',
					title: translated,
				})
			}
			// else if(data == 'User doesn`t exist!'){

			// }else{
			// 	data == 'Password incorrect!'
			// }
				
		}).error(function (error) {
			
		});

	}


	
	function populateStorage(register = false) {

        $scope.storageInfo = {
            Email: $scope.Email,  
			MembershipID: $scope.theChoosenMembership.ServiceDefinitionID,
			GymID: $scope.DivisionID
        }

        if(register){
            $scope.storageInfo.FirstName = $scope.FirstName;
            $scope.storageInfo.LastName = $scope.LastName;
			$scope.storageInfo.Telephone = $scope.inputPhone.telInput.value;
            $scope.storageInfo.TelCode = $scope.inputPhone.selectedDialCode.innerHTML;
            $scope.storageInfo.Email = $scope.Email;
        }

		if(userID){
			$scope.storageInfo.userID = userID;
		}

        sessionStorage.setItem('storageinfo', JSON.stringify($scope.storageInfo));
		// sessionStorage.clear();
    }


	function registerUser(){

		var startDate = new Date($scope.theChoosenMembershipDate);
		startDate.setHours(0,0,0,0);
		var number = $scope.inputPhone.selectedDialCode.innerHTML + $scope.inputPhone.telInput.value;
		number = number.replace(/ /g,'');

		
		let dataObject = {
			Namespace: namespace,
			GymID: $scope.DivisionID,
			PortalVersion: 'v2',
			model: { FirstName: $scope.FirstName, LastName: $scope.LastName, Email: $scope.Email, Password: $scope.Password, NewAccount: $scope.NewAccount, Telephone: number, Note: $scope.Note }
		}

		$http({
			method: 'POST',
			url: '/Membership/RegisterUser',
			data: dataObject
		}).success(function (data) {
			let result = data.Value;
			if(result == 'Success'){

				let translated = $translateThis('Registration successful');
				Swal.fire({
					type: 'success',
					title: translated,
					onAfterClose: (function () {
						checkServicesToPurchase();
                    })
				});
				$scope.validateUser = true;
				$scope.getTerms('netcashmandate');
				$([document.documentElement, document.body]).animate({
					scrollTop: $("#checkout").offset().top
				}, 1000);
			}else{

				if(result.includes(" is already taken.")){
					let email = result.split(' is already taken.');
					email = email[0].split('Name ');
					email = email[1];

					result = $translateThis('Email is already taken', {value: email});
				}

				Swal.fire({
					type: 'warning',
					title: result
				});
			}
		}).error(function (error) {
			
		});
	}
    // CheckWaiver(string Email, int? ClientID, int MembershipID, int GymID, string Namespace)

	//setup before functions
	var typingEmail;
	var $inputEmail = $('#Email');

	//on keyup, start the countdown
	// $inputEmail.on('keyup', function () {
	//   	clearTimeout(typingEmail);
	//   	if($scope.choosenMembership && $inputEmail.is('.ng-valid') && !$scope.NewAccount)
	// 		typingEmail = setTimeout(function() {checkWaiver()}, 2000);
	// });

	//on keydown, clear the countdown 
	$inputEmail.on('keydown', function () {
		clearTimeout(typingEmail);
	});

	var checkServicesToPurchaseInProgress = false;
	function checkServicesToPurchase(email){
		if (checkServicesToPurchaseInProgress) return;
		checkServicesToPurchaseInProgress = true;

		let dataObject = {
			Namespace: namespace,
			GymID: $scope.DivisionID,
			ServiceDefinitionID: $scope.theChoosenMembership.ServiceDefinitionID,
			ClientID: $scope.clientGroupMember ? $scope.clientGroupMember.ClientID : -1,
			Email: email ? email : $scope.Email
		}

		//  CheckServicesToPurchase(int ServiceDefinitionID, int? ClientID, string Email, int GymID, string Namespace)
		$http({
			method: 'POST',
			url: '/Membership/CheckServicesToPurchase',
			data: dataObject
		}).success(function (data) {
			checkServicesToPurchaseInProgress = false;
			if (data.CanPurchaseService === false && data.ServicesToPurchase) {
				var translated = $translateThis('You need to purchase the following services first:');
				Swal.fire({
					type: 'warning',
					title: translated,
					text: data.ServicesToPurchase
				});
			} else {
				checkWaiver();
			}
		}).error(function (error) {
			checkServicesToPurchaseInProgress = false;
			checkWaiver();
		});
	}

	function checkWaiver(){

		let dataObject = {
			Namespace: namespace,
			GymID: $scope.DivisionID,
			MembershipID: $scope.theChoosenMembership.ServiceDefinitionID,
			ClientID: -1,
			Email: $scope.Email
		}
		
		$http({
			method: 'POST',
			url: '/Membership/CheckWaiver',
			data: dataObject
		}).success(function (data) {
			if(data.IsWaiverRequired){
				populateStorage($scope.NewAccount);
				let translated = $translateThis('Waiver Required!');
				let divisionID = data.DivisionID ? data.DivisionID : $scope.DivisionID;
				
				if(data.WaiverTitle){
					translated = $translateThis('Waiver Required WaiverName!', { waiverName: data.WaiverTitle });
				}

				let waiverHref = window.location.origin + '/waiver/embedregistration?GymID=' + divisionID + '&NameSpace=' + namespace + '&Redirect=/membership/purchasev2';
				if(data.MainWaiverID > 0){
					waiverHref += '#WavID=' + data.MainWaiverID;
				}
				Swal.fire({
					type: 'warning',
					title: translated,
					showCancelButton: true,
				}).then(function(result) {
					if (result.value) {
						window.location.href = waiverHref;
					}else{
						sessionStorage.clear();
						$timeout(function() {
							$scope.onePageloading = false;
						}, 1);
					}
				});
			}
		}).error(function (error) {
			
		});
	}

	function getPrice(price, discount) {         
		var numVal1 = Number(price);
		var numVal2 = Number(discount);

		var totalValue = numVal1 * ( (100-numVal2) / 100 )
		return totalValue.toFixed(2);
	}

	
	$scope.changePromoCode = function () {

		if ($scope.PromoCode.length > 3) {
			var dataObject = {
				Namespace: namespace,
				GymID: $scope.DivisionID,
				ClientID: clientId ? clientId : -1,
				ServiceID: $scope.theChoosenMembership.ServiceDefinitionID,
				orderType: $scope.orderType,
				DateStart: $scope.theChoosenMembershipDate,
				PromoCode: $scope.PromoCode,
				Discount: $scope.Discount,
				Email: $scope.Email
			}
			// if (dataObject.GymID == undefined)
			//     dataObject.GymId = $scope.Model.GymId;
			// if ($scope.orderCardId == undefined && $scope.serviceDefinitionId != undefined)
			// 	dataObject.ServiceID = $scope.serviceDefinitionId;
			$http({
				method: 'POST',
				url: '/Membership/ValidatePromoCode',
				data: dataObject
			}).success(function (data) {
				$scope.promocodeFalse = false;
				if (data != 'false') {
					$scope.Discount = data.DiscountPercent;
					// if ($scope.orderCardId != undefined && $scope.serviceRealID == undefined)
					// 	$scope.serviceRealID = $scope.orderCardId;

					$scope.theChoosenMembership.OriginalPrice = getPrice($scope.theChoosenMembership._originalPrice, data.DiscountPercent)
					// getTermsForMembership();
				}else{
					$scope.promocodeFalse = true;
				}
			}).error(function () {
				// console.log('error');
			});
		}
	};


	

	function stripeConfirmCard(secret){
		let name = $scope.Email;
		if( $scope.NewAccount )
			name = $scope.FirstName + ' ' + $scope.LastName;

		$scope.stripe.confirmCardPayment(secret, {
			payment_method: {
				card: $scope.card,
				  billing_details: {
					name: name
				  }
			}
		}).then(function(result) {
			if (result.error) {
				// Show error to your customer (e.g., insufficient funds)
				$scope.stripeError.textContent = result.error.message;;
				$timeout(function() {
					$scope.onePageloading = false;
				}, 100);
			} else {

				  // The payment has been processed!
				  if (result.paymentIntent.status === 'succeeded') {
					$scope.card.clear();
					$scope.placeOrder(true);
					// Show a success message to your customer
					// There's a risk of the customer closing the window before callback
					// execution. Set up a webhook or plugin to listen for the
					// payment_intent.succeeded event that handles any business critical
					// post-payment actions.
				  }
			}
		});
	}

	if (namespace) {
		$scope.namespace = namespace;
		$scope.getSettings = function () {
			var dataObject = {
				Namespace: namespace,
				GymID: $scope.DivisionID
			}
			$http({
				method: 'POST',
				url: '/Membership/GetSettings',
				data: dataObject
			}).success(function (data) {
				$scope.membershipSettings = data;
				$scope.countriesSettings = data.Countries;
				window.membershipCurrencyCode = data.CurrencyCode; // <-- Set currency code globally
				checActivePaymentMethods($scope.membershipSettings);
			}).error(function () {
				// ...existing code...
			});
		}

		$scope.getSettings();
	}

	$scope.forgotpassword = function(){
		let href = window.location.origin + '/account/ForgotPasswordv2?namespace=' + namespace + '&GymID='+$scope.DivisionID;
		window.location.replace(href);
	}

	$scope.$watch('NewAccount', function (v) {

		$timeout(function() {
			if ( v == true ) {
				if ($('#Password').val() == $('#ConfirmPassword').val()) {
					$('.validation-errors').html('');
					$timeout(function() {
						$scope.ConfirmPasswordHidden = true;
					})
				} else {
					$timeout(function() {
						$scope.ConfirmPasswordHidden = false;
					})
					$('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
				}
			}else{
				$scope.ConfirmPasswordHidden = true;
			}
		})
	});

    $(window).on('load', function(){
		$timeout(function() {
			if ( $scope.theChoosenMembership && $scope.theChoosenMembership.OriginalPrice == 0 ){
				$scope.theChoosenMembershipIsFree = true;
				$('#payment-free').prop("checked", true).trigger("click");
				$scope.paymentway = 0;
			}else{
				$scope.theChoosenMembershipIsFree = false;
			}
		});

		$('.header .logo').attr('href', '');

		if ( $('.payment-method .sections .section.active').length == 1 ){
			$('.payment-method .sections .section.active input[name="mainPaymentWay"]').prop('checked', true);
			$scope.mainPaymentWay = $('.payment-method .sections .section.active input[name="mainPaymentWay"]').val();
			$scope.$apply();
		}

		setTimeout(function() {
			$('#sc-style-modal').remove()
		}, 3000);

		if( $('#Password').length && $('#ConfirmPassword').length ){
			var translated = $translateThis('notMaching');
			$scope.ConfirmPasswordHidden = false;
			$('#Password, #ConfirmPassword').on('keyup', function () {
				if($scope.NewAccount){
					if ($('#Password').val() == $('#ConfirmPassword').val()) {
						$('.validation-errors').html('');
						$timeout(function() {
							$scope.ConfirmPasswordHidden = true;
						})
					} else {
						$timeout(function() {
							$scope.ConfirmPasswordHidden = false;
						})
						$('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
					}
				}
			});
		}

		if($scope.theChoosenMembership && $scope.theChoosenMembership.FixedDate){
			let membershipDate = new Date($scope.theChoosenMembership.FixedStartingDate);

			$timeout(function() {
				$scope.theChoosenMembershipDate = membershipDate;
			})
		}

		$scope.ConfirmPasswordHidden = true;

		if ( memberships ) {
			$scope.memberships = memberships;

			if ( $scope.memberships.length == 1 ) {

				setTimeout(function() {
					$scope.currentGym = $scope.membershipGyms.find(o => o.GymID === $scope.DivisionID);
				}, 3000);

				$scope.lockMembership = true;

				// Wait for settings/currency code before continuing
				function afterCurrencyReady() {
					$scope.theChoosenMembership = $scope.memberships[0];
					getFinalPrice($scope.theChoosenMembership.OriginalPrice);

					if($scope.theChoosenMembership.FixedDate){
						let now = new Date();
						now.setHours(0,0,0,0);
						let membershipDate = new Date($scope.theChoosenMembership.FixedStartingDate);
						$scope.theChoosenMembershipDate = membershipDate;
						$('#membdatepicker').datepicker('setDate', new Date(membershipDate));
						$('#membdatepicker').datepicker('disable');

						if(membershipDate >= now){
							$scope.expiredStartingDate = false;
						}else{
							$scope.expiredStartingDate = true;
						}
					}else{
						$scope.expiredStartingDate = false;
						$scope.theChoosenMembershipDate = new Date();
						$('#membdatepicker').datepicker('setDate', new Date(today));
						$('#membdatepicker').datepicker('enable');
					}

					// $scope.theChoosenMembership.Fibank = true;
					// $scope.orderCardReccuring = ($scope.theChoosenMembership.Fibank != true) ? false : true;
					if( $scope.theChoosenMembership.Fibank == true ){
						$scope.orderCardReccuring = true;
					}else{
						$scope.orderCardReccuring = false;  
					}

					$scope.getTerms();

					$scope.choosenMembership = true;
					if($scope.theChoosenMembership.RequiresAdditionalConfirmationOnline){
						$scope.additionalConfirmationOnline = false;
					}
				}
				if (window.membershipCurrencyCode) {
					afterCurrencyReady();
				} else {
					var waitForCurrency = setInterval(function() {
						if (window.membershipCurrencyCode) {
							clearInterval(waitForCurrency);
							afterCurrencyReady();
						}
					}, 100);
				}
			}
		}
	})

}]);